import { BMotionObject } from "./BMotionObject";
import { BMotionType } from "../Animations/BMotionEnums";
import { Constants } from "../Misc/Constants";
import { NumPair, Point } from '../Misc/Utils';
import { ObjectType } from './ObjectTypeEnum';

export class BImage extends BMotionObject{
    protected readonly TYPE = ObjectType.IMAGE;
    
    img : HTMLImageElement 
    tempCanvasDimen: NumPair

    constructor(centre: NumPair, imgSrc : string, frameRange : NumPair, canvasDimen: NumPair){
        super(centre,[0,0], frameRange);
        this.uniformScaling = true;
        this.img = new Image();
        this.img.onload = this.imageLoaded;
        this.img.src = imgSrc;
        this.isVisible = false;
        this.tempCanvasDimen = canvasDimen;
    }

    public imageLoaded = () => {
        this.isVisible = true;
        if(this.wh[0] == 0 && this.wh[1] == 0){
            //only if new loading
            //this.setWH([this.img.width, this.img.height]);
            this.calculateOptimalWH([this.img.width, this.img.height]);
            console.log("resetting");
        }
    }

    private calculateOptimalWH(imgOriginalWH: NumPair){
        if(imgOriginalWH[0] > this.tempCanvasDimen[0] || imgOriginalWH[1] > this.tempCanvasDimen[1]){
            if(imgOriginalWH[0]>imgOriginalWH[1]){
                //landscape img
                var ratio = this.tempCanvasDimen[0]/imgOriginalWH[0];
                this.setWH([this.tempCanvasDimen[0], ratio*imgOriginalWH[1]]);
            }else{
                //portrait img
                var ratio = this.tempCanvasDimen[1]/imgOriginalWH[1];
                this.setWH([ratio*imgOriginalWH[0], this.tempCanvasDimen[1]]);
            }
        }
    }

    public getImageSrc() : string{
        return this.img.src;
    }

    protected justDrawObj(canvasCtx : CanvasRenderingContext2D): void{
        canvasCtx.drawImage(this.img, -this.wh[0]/2, -this.wh[1]/2, this.wh[0], this.wh[1]);
    }

    public clone() : BImage{
        var dupCenter = [this.getCentre()[0], this.getCentre()[1]];
        var dupFrameRange = [this.getFrameRange()[0], this.getFrameRange()[1]];
        var dupObj : BImage = new BImage(dupCenter as NumPair, this.getImageSrc(), dupFrameRange as NumPair, this.tempCanvasDimen); //tempCanvasDimen could be stale
        super.duplicate(dupObj);
        return dupObj;
    }

}